module.exports = __webpack_public_path__ + "img/img4.7da160f9.jpg";